import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { AppRoutingModule } from './routing/routing.module';
import { AppConfigService } from '@config/main';
import { RootComponent } from './root/root.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { MaterialModule } from '@shared/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DisableDirective } from '@shared/services/utils/disable.directive';
import { PercentagePipe } from '@shared/pipes/percentage.pipe';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { OverviewPageComponent } from './overview-page/overview-page.component';
import { NavBarComponent } from './shared/components/nav-bar/nav-bar.component';
import { ResidentEnrollmentPortalComponent } from './resident-enrollment-portal/resident-enrollment-portal.component';

import { LoginComponent } from './login/login.component';
import { RosterPageComponent } from './roster-page/roster-page.component';
import { RosterTableComponent } from './roster-page/roster-table/roster-table.component';
import { ResidentSearchDialogComponent } from './roster-page/resident-search-dialog/resident-search-dialog.component';
import { ResidentSearchResultDialogComponent } from './roster-page/resident-search-result-dialog/resident-search-result-dialog.component';
import { NewResidentDialogComponent } from './roster-page/new-resident-dialog/new-resident-dialog.component';
import { OitePageComponent } from './oite-page/oite-page.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { ResidentRemoveDialogComponent } from './roster-page/resident-remove-dialog/resident-remove-dialog.component';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { EditResidentComponent } from './roster-page/edit-resident/edit-resident.component';
import { OitePaidSeatsTableComponent } from './oite-page/oite-paid-seats-table/oite-paid-seats-table.component';
import { SuccessModalComponent } from '@shared/components/success-modal/success-modal.component';
import { FailModalComponent } from '@shared/components/fail-modal/fail-modal.component';
import { AdminPageComponent } from './admin/admin-page.component';
import { ResidentCurriculumPageComponent } from './resident-curriculum/resident-curriculum-page/resident-curriculum-page.component';
import { ResidentCurriculumTableComponent } from './resident-curriculum/resident-curriculum-table/resident-curriculum-table.component';
import { OrderSummaryPageComponent } from './order-summary-page/order-summary-page.component';
import { ProductsTableComponent } from './order-summary-page/products-table/products-table.component';
import { SubscriptionsTableComponent } from './order-summary-page/subscriptions-table/subscriptions-table.component';
import { ResidentTransitionDialogComponent } from './roster-page/resident-transition-dialog/resident-transition-dialog.component';
import { DinoSpinnerComponent } from './shared/components/dino-spinner/dino-spinner.component';
import { FacultyPageComponent } from './faculty-page/faculty-page.component';
import { FacultyTableComponent } from './faculty-page/faculty-table/faculty-table.component';
import { NewFacultyDialogComponent } from './faculty-page/new-faculty-dialog/new-faculty-dialog.component';
import { RemoveFacultyDialogComponent } from './faculty-page/remove-faculty-dialog/remove-faculty-dialog.component';
import { FacultySearchDialogComponent } from './faculty-page/faculty-search-dialog/faculty-search-dialog.component';
import { FacultySearchResultDialogComponent } from './faculty-page/faculty-search-result-dialog/faculty-search-result-dialog.component';

export function loadConfigService(configService: AppConfigService) {
  return () => {
    return configService.load();
  };
}

@NgModule({
  declarations: [
    RootComponent,
    PageNotFoundComponent,
    DisableDirective,
    PercentagePipe,
    OverviewPageComponent,
    NavBarComponent,
    ResidentEnrollmentPortalComponent,
    LoginComponent,
    RosterPageComponent,
    RosterTableComponent,
    ResidentSearchDialogComponent,
    ResidentSearchResultDialogComponent,
    NewResidentDialogComponent,
    UnauthorizedComponent,
    SpinnerComponent,
    ResidentRemoveDialogComponent,
    EditResidentComponent,
    OitePageComponent,
    SuccessModalComponent,
    FailModalComponent,
    OitePaidSeatsTableComponent,
    AdminPageComponent,
    ResidentCurriculumPageComponent,
    ResidentCurriculumTableComponent,
    OrderSummaryPageComponent,
    ProductsTableComponent,
    SubscriptionsTableComponent,
    ResidentTransitionDialogComponent,
    DinoSpinnerComponent,
    FacultyPageComponent,
    FacultyTableComponent,
    NewFacultyDialogComponent,
    RemoveFacultyDialogComponent,
    FacultySearchDialogComponent,
    FacultySearchResultDialogComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    MaterialModule,
    FormsModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatTableModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfigService,
      deps: [AppConfigService, HttpClientModule],
      multi: true
    }
  ],
  bootstrap: [RootComponent]
})
export class AppModule { }
